import { render } from "./SuppliersPage.vue?vue&type=template&id=e8c9e512&scoped=true"
import script from "./SuppliersPage.vue?vue&type=script&lang=js"
export * from "./SuppliersPage.vue?vue&type=script&lang=js"

import "./SuppliersPage.vue?vue&type=style&index=0&id=e8c9e512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c9e512"]])

export default __exports__